import useDomainConfigurationModalActions from './useDomainConfigurationModalActions'

export default useDomainConfigurationModalActions
